import { render } from "./ReviewSentRequestDonePage.vue?vue&type=template&id=0a428b6f&scoped=true&ts=true"
import script from "./ReviewSentRequestDonePage.vue?vue&type=script&lang=ts"
export * from "./ReviewSentRequestDonePage.vue?vue&type=script&lang=ts"

import "./ReviewSentRequestDonePage.vue?vue&type=style&index=0&id=0a428b6f&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a428b6f"]])

export default __exports__